<template>
  <div id="app">
    <!-- navbar begin -->
    <div class="no-print" uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky">
        <nav class="uk-navbar-container" id="grad" style="background-color:#0097c5;box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);" uk-navbar="dropbar: true;">

                <div class="uk-navbar-left">
            
                    <ul class="uk-navbar-nav" >
                        <li>
                            <a href="#"><span class="uk-icon-link uk-margin-small-right uk-margin-small-left active" uk-icon='icon: menu; ratio: 1.6' style="color:white;"></span></a>
                            
                            <div class="uk-navbar-dropdown">
                                <ul class="uk-nav uk-navbar-dropdown-nav">
                                    <li><router-link :to="'/'+ ((f != null) ? '?f='+f : '')">Home</router-link></li>
                                    <li class="uk-nav-divider"></li>
                                </ul>
                            </div>
                        </li>
                        <!-- <li class="uk-active"><a href="#">Menu</a></li> -->
                    </ul>
            
                </div>

                <div  class="uk-navbar-center uk-light uk-margin-small">
                   <!-- <router-link :to="'/'" > <h2> <span > 5c </span></h2></router-link> -->
                   <h2> <span >Prospecting</span></h2>
                </div>

        </nav>
        <div class="uk-navbar-dropbar"></div>
    </div>
    <!-- navbar end -->

    <router-view @login="showModal" class="uk-container"/>

    <hr class="uk-margin-medium-top no-print">

      <!-- footer -->
    
      <div class=" no-print uk-margin uk-padding uk-text-center" uk-grid>
        <div>
          <p> Solicita tu crédito en tu cooperativa</p>
        </div>
        <!-- <div>      
          <p><a  class="uk-text-link uk-link-text" href="mailto:midoctmpn@gmail.com">Contacto por correo a midoctmpn@gmail.com</a></p>
        </div>
        <div>      
          <p><a  class="uk-text-link uk-link-text" href="https://wa.me/5215580138994">Contacto en México al +52-1-55-8013-8994</a></p>
        </div>
        <div>      
          <p><a  class="uk-text-link uk-link-text" href="https://wa.me/593992659214">Contacto en Ecuador al +593-992659214</a></p>
        </div>
        <div>      
          <p class="uk-text-link uk-link-text" >Oficina Matriz: Fray Angelico, colonia Nonoalco, Ciudad de México</p>
        </div> -->
      </div>



          
  </div>
</template>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* nav {
  padding: 30px;
} */

nav a {
  font-weight: bold;
  color: #2c3e50;
}

.uk-button-primary {
  background-color: #0097c5;
}

hr{
  height:1px;
  border:none;
  background-color: #0097c5;
}
.print-only{
  display: none;
}
@media print
{    
    .no-print, .no-print *
    {
        display: none !important;
        padding: 0%;
    }
    .print-only{
      display: block;
    }
    
    #nav {
      padding: 0px;
    }
    h1 {
      padding: 0px;
    }
    h3 {
      padding: 0px;
    }
}
</style>

<script>
export default {
  data:function(){
    return {
      pass : '',
      loading : false,
      f : '',
    }
  },
  mounted:function(){
      var url_params = new URLSearchParams(window.location.search);
      this.f = url_params.get('f')
      if(this.f){
        sessionStorage.setItem('f',this.f)
      } else if(!sessionStorage.getItem('f')) {
        sessionStorage.setItem('f','integral')
      }
  }, 
  methods:{
    showModal : showModal,
    onContinue : onContinue
  }
}


function showModal( ) {
    UIkit.modal(document.getElementById('modal-example')).show() 
}

function onContinue() {
  timer.start({precision: 'seconds'})
  this.$router.push('1c')
}
</script>
